export const isBaseColor = (color: string) => {
    return ["primary", "secondary", "tertiary"].includes(color)
}